/**
 * itprocessreducer.js
 **/

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function itProcessReducer(state = initialState.itprocess, action) {
	switch (action.type) {
		case types.GET_ITPROCESS_VALIDATION_COUNT:
			  return {...state, itProcessValidationsCount: action.response?.data?.length }

		case types.UPDATE_ITPROCESS: {
			if (action.response && action.responseObj.status === 200 && !action?.isManageEntities) {
				const newState = {...state};

				if (newState.data?.length > 0) {
					newState.data = newState.data.map((itProcess) => {
						if (itProcess.id === action.response.id) {
							return {
								...itProcess,
								itProcessName: action.response.itProcessName,
								taskTitle: action.response.taskTitle,
								taskDescription: action.response.taskDescription
							};
						}
						return itProcess;
					});
				} else {
					newState.data = {
						...newState.data,
						itProcessName: action.response.itProcessName,
						taskTitle: action.response.taskTitle,
						taskDescription: action.response.taskDescription
					};
				}
				return newState;
			}
			return state;
		}

		case types.GET_ALL_ITPROCESSES: {
			if (action.isManageEntities) {
				return state;
			}
			return {...state, ...(action.response)};
		}

		case types.DELETE_ITPROCESS: {
			if (action.responseObj.status === 200 && !action?.isManageEntities) {
				return {
					...state, // Keep the existing state properties
					data: state.data.filter((itProcess) => itProcess.id !== action.itProcessId), // Filter out the deleted item
					page: action.response.page || state.page, // Update pagination details if provided
					pages: action.response.pages || state.pages,
					totalEntityCount: action.response.totalEntityCount || state.totalEntityCount
				};
			}
			return state;
		}

		default:
			return state;
	}
}
